import React from 'react';
import customizeComponentMap from '../Constants/CustomizeComponentMap';
import withAnchor from '../../../components/Anchor/withAnchor';

const CustomizeComponentFactory = (props) => {
  const { ecmContent, ...rest } = props;
  const { key, anchor } = ecmContent;

  const Component = customizeComponentMap.get(key) || (() => <></>);

  if (anchor) {
    const AnchoredComponent = withAnchor(Component);
    return <AnchoredComponent anchor={anchor} ecmContent={ecmContent} {...rest} />;
  }

  return <Component ecmContent={ecmContent} {...rest} />;
};

export default CustomizeComponentFactory;
